import { ApiEndpoints } from "../../utils/app-constants";
import { toCondensedDate, toShortDate } from "../../utils/date-utils";
import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../utilities/document-request";
import { API_METHODS, CONTENT_TYPES } from "../utilities/type-models";

export class RollFormingPaperworkDocument implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab: boolean = false;
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'POST';
    public data: any = {};
    public contentType: CONTENT_TYPES = "multipart/form-data"

    public url: string = '';

    constructor(startDate: Date, endDate: Date, overridesFile: any) {
        var startDateStr = toShortDate(startDate);
        var endDateStr = toShortDate(endDate);
        this.data = new FormData();
        if (overridesFile) {
            this.data.append("file", overridesFile);
        }
        this.url = ApiEndpoints.REPORTS_ROLL_FORMING_PAPERWORK.formattify(startDateStr, endDateStr);
        this.filename = `RollForming_${toCondensedDate(startDate)}_${toCondensedDate(endDate)}`;
    }
}
